var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 19,
    fill: "none",
    viewBox: "0 0 26 19"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#minus_svg__a)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 18,
    height: 4,
    x: 4,
    y: 7,
    fill: "url(#minus_svg__b)",
    rx: 2
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "minus_svg__b",
    x1: 13,
    x2: 13,
    y1: 11,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#B25200"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.08,
    stopColor: "#F58F00"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.604,
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgMinus;